// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settings-title {\n  justify-content: center;\n  font-size: 1.4rem;\n  font-weight: 700;\n}\n\n.verifiedIcon{\n  position : absolute;\n  top: 0;\n  right: -6px;\n  z-index: 1;\n  width: 38px !important;\n  height: 38px !important;\n}", ""]);
// Exports
module.exports = exports;
